/* tslint:disable */

declare var Object: any;
export interface SFAttendanceListInterface {
  "id"?: number;
}

export class SFAttendanceList implements SFAttendanceListInterface {
  "id": number;
  constructor(data?: SFAttendanceListInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `SFAttendanceList`.
   */
  public static getModelName() {
    return "SFAttendanceList";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of SFAttendanceList for dynamic purposes.
  **/
  public static factory(data: SFAttendanceListInterface): SFAttendanceList{
    return new SFAttendanceList(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'SFAttendanceList',
      plural: 'SFAttendanceLists',
      path: 'SFAttendanceLists',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/SFAttendanceList.ts